import React from 'react';
import { AnimatedIcon } from '@shell-b2c/web-design-system';

export const PaperAirplaneAnimation = (props) => {
  return <AnimatedIcon type="airplane" {...props} />;
};

export default PaperAirplaneAnimation;
